import React from 'react';

const BranchLabelBanner = ({ branchLabel, style = {} }) => (
  <div
    style={{
      margin: '0 auto 20px',
      padding: '14px 20px',
      width: 'calc(100% - 40px)',
      maxWidth: '720px',
      boxSizing: 'border-box',
      backgroundColor: '#e8fafa',
      border: '2px solid #00b9b9',
      borderRadius: '8px',
      color: '#006b6b',
      direction: 'rtl',
      textAlign: 'center',
      fontSize: '24px',
      fontWeight: 'bold',
      ...style,
    }}
  >
    نوع الجذع المختار: {branchLabel || 'غير محدد'}
  </div>
);

export default BranchLabelBanner;
